import React from "react";

// Custom components.
import { IconValueSlider } from "../Sliders/Sliders";

// Icons
import { ReactComponent as SemanticSegmentationIcon } from "./Icons/semantic_segmentation.svg";
import { ReactComponent as ClassificationIcon } from "./Icons/classification.svg";

import { SparklesIcon } from "@heroicons/react/24/solid";

const CalculationButton = (props) => {
  const {
    semanticZC,
    setSemanticZC,
    classificationZC,
    setClassificationZC,
    comparisonItems,
    imageProcessingStatuses,
    calculateEntry,
    buttonPrompt,
    entryType,
  } = props;

  const handleClick = () => {
    calculateEntry();
  };

  const getCardStyle = ({
    entryType,
    comparisonItems,
    imageProcessingStatuses,
  }) => {
    const isActive = entryTypeStyleLogic[entryType](
      comparisonItems,
      imageProcessingStatuses
    );
    return isActive ? {} : { pointerEvents: "none", opacity: "0.5" };
  };

  // Object which holds conditions for calculation button to be active. Object keys are entryTypes
  const entryTypeStyleLogic = {
    segmentation: (comparisonItems, imageProcessingStatuses) =>
      // Front OR Back input images must be present for segmentation.
      // Images must not be currently being processed.
      (comparisonItems[0].fileOne[0] || comparisonItems[1].fileOne[0]) &&
      imageProcessingStatuses[0] !== "serverProcessing" &&
      imageProcessingStatuses[1] !== "serverProcessing",

    regular: (comparisonItems, imageProcessingStatuses) =>
      // Input image must be present.
      comparisonItems[0].fileOne[0] &&
      // Image must not be currently being processed.
      imageProcessingStatuses[0] !== "serverProcessing",

    // Add logic for new entry types here
  };

  return (
    <div
      className="flex flex-col w-full Xbg-red-500"
      style={getCardStyle({
        entryType: entryType,
        comparisonItems: comparisonItems,
        imageProcessingStatuses: imageProcessingStatuses,
      })}
    >
      {/* Coefficients must be present. Only show sliders for Psoriasis and PsoriasisSegmentation */}
      {semanticZC && classificationZC && (
        <>
          <div className="flex flex-col lg:flex-row Xh-10 w-full justify-center items-center Xbg-red-500">
            <div className="flex flex-1 flex-row items-center justify-start w-full">
              <p className="text-neutral-900 text-xl font-medium">
                Semantic Segmentation Zoom Coefficient
              </p>
            </div>
            <div className="flex flex-1 flex-row items-center justify-end w-full pt-2 lg:pt-0 Xbg-purple-500">
              <IconValueSlider
                sliderValue={Number(semanticZC).toFixed(2)}
                sliderMin={0.1}
                sliderMax={1}
                sliderStep={0.05}
                onChangeFunction={(event) => {
                  setSemanticZC(event.target.value);
                }}
                Icon={SemanticSegmentationIcon}
              />
            </div>
          </div>

          <div className="py-2" />

          <div className="flex flex-col lg:flex-row Xh-10 w-full justify-center items-center Xbg-red-500">
            <div className="flex flex-1 flex-row items-center justify-start w-full">
              <p className="text-neutral-900 text-xl font-medium">
                Classification Zoom Coefficient
              </p>
            </div>
            <div className="flex flex-1 flex-row items-center justify-end pt-2 lg:pt-0 w-full Xbg-purple-500">
              <IconValueSlider
                sliderValue={Number(classificationZC).toFixed(2)}
                sliderMin={0.1}
                sliderMax={1}
                sliderStep={0.05}
                onChangeFunction={(event) => {
                  setClassificationZC(event.target.value);
                }}
                Icon={ClassificationIcon}
              />
            </div>
          </div>

          <div className="py-2" />
        </>
      )}

      {/* Calculate button */}
      <div className="flex flex-row w-full">
        <button
          className={`
                      flex flex-row items-center justify-center space-x-2
                      px-3 py-4 w-full rounded-lg select-none 
                    bg-emerald-100 active:bg-emerald-200
                      hover:bg-opacity-80 active:bg-opacity-100 
                     `}
          onClick={handleClick}
        >
          <SparklesIcon className="h-6 w-6 text-neutral-800 stroke-2" />
          <p className="text-2xl font-medium text-neutral-800">
            {buttonPrompt}
          </p>
        </button>
      </div>
    </div>
  );
};

export default CalculationButton;
